import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  getTrendingArticles() {
    const url = `api/home/trending-articles`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  readArticle(body) {
    const url = `api/home/article`;
    return this.httpService.patch(url, body).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  likeArticle(body) {
    const url = `api/home/article`;
    return this.httpService.patch(url, body).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getFeedArticles(page) {
    const url = `api/home/article/${page}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getArticlesCount() {
    const url = `api/home/article-count`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  // method to exit from impersonating user
  exitFromImpersonating() {
    const url = `api/user/switch-account-stop`;
    return this.httpService.post(url).pipe(
      map((response: any) => {
        return response;
      })
    );
  }

  // method to start impersonating user
  startImpersonating(switchToUserId: number, switchFromUserId: number) {
    const url = `api/user/switch-account-start`;
    return this.httpService
      .post(
        url,
        {
          switch_to_user_id: switchToUserId,
          switch_from_user_id: switchFromUserId,
        },
        loaderTypes.mainAnimation
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      );
  }
}
